<template>
  <div>
    <slot :viewFile="viewFile" />

    <v-dialog v-model="dialog" :attach="attach" fullscreen>
      <div class="view-container">
        <div
          class="viewer-button viewer-close"
          data-viewer-action="mix"
          role="button"
          tabindex="0"
          @click="onClose"
        ></div>
        <!-- <v-btn class="btn-file-view" color="white" dark fab size="36" small>
          <v-icon color="#000" size="24">mdi-close</v-icon>
        </v-btn> -->
        <div class="d-flex justify-center align-center file-container">
          <ImageView v-if="type == 'image'" :file="fileView" />
          <!-- <PdfView v-else-if="type == 'pdf'" :src="fileView.path" /> -->
          <VideoView v-else-if="type == 'video'" :file="fileView" />
          <div v-else>
            Không hỗ trợ xem trước
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ImageView from './view/image-view.vue'
// import PdfView from "./view/pdf-view.vue";
import VideoView from './view/video-view.vue'
export default {
  components: {
    ImageView,
    // PdfView,
    VideoView,
  },
  props: { attach: {} },
  provide() {
    return { viewFile: this.viewFile }
  },
  data: () => ({
    dialog: false,
    fileView: {},
    isShowImageView: false,
    isShowPdfView: false,
    isShowVideoView: false,
    type: '',
  }),
  computed: {},
  methods: {
    onClose() {
      this.dialog = false
      this.fileView = {}
    },
    viewFile(file, type) {
      this.fileView = file
      this.type = type
      if (type == 'image') {
        // this.isShowImageView = true
        this.$viewerApi({
          images: [this.fileView.path],
          options: {
            navbar: false,
            toolbar: {
              zoomIn: true,
              zoomOut: true,
              oneToOne: true,
              rotateLeft: true,
              rotateRight: true,
              flipHorizontal: true,
              flipVertical: true,
              reset: true,
              play: false,
              next: false,
              prev: false,
            },
          },
        })
        return
      }

      this.dialog = true
      if (type == 'pdf') {
        this.isShowPdfView = true
      } else if (type == 'video') {
        this.isShowVideoView = true
      }
    },
  },
}
</script>

<style scoped lang="scss">
.view-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000075;

  .btn-file-view {
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .file-container {
    width: 75vw;
    height: 75vh;
  }
}
</style>
